import { IntegrationLookup } from '../../models/integration-lookup.model';
import { Action, createReducer, on } from '@ngrx/store';
import { IntegrationManagev2Actions } from './integration-managev2-config.actions';
import { PublishedVersions } from '../../models/integration/published-version.model';

export interface IntegrationManagev2State {
    integrationLookup: IntegrationLookup;
    filename: string;
    filenames: string[];
    fileContent: string;
    isLoading: boolean;
    isSaving: boolean;
    versions?: string[];
    publishedVersions: PublishedVersions;
    selectedVersion?: string;
}

export enum HttpResponseStatus {
    Success,
    Failed,
    None
}

export const IntegrationManagev2InitialState: IntegrationManagev2State = {
    integrationLookup: {
        clientIntegrationType: {}
    },
    filename: '',
    filenames: [],
    fileContent: '',
    isLoading: false,
    isSaving: false,
    versions: [],
    publishedVersions: {
        identifier: { clientName: '', integrationType: '' },
        publishedVersions: []
    },
    selectedVersion: ''
};

export const integrationManagev2Reducer = (
    reducerState: IntegrationManagev2State,
    reducerAction: Action
): IntegrationManagev2State => {
    return createReducer(
        IntegrationManagev2InitialState,
        on(
            IntegrationManagev2Actions.getIntegrationLookup,
            (state): IntegrationManagev2State => ({
                ...state,
                isLoading: true,
                fileContent: '',
                filenames: [],
                filename: '',
                versions: [],
                publishedVersions: {
                    identifier: { clientName: '', integrationType: '' },
                    publishedVersions: []
                }
            })
        ),
        on(
            IntegrationManagev2Actions.setIntegrationLookup,
            (state, action): IntegrationManagev2State => ({
                ...state,
                integrationLookup: action.integrationLookup,
                isLoading: false,
                filenames: [],
                isSaving: false,
                fileContent: '',
                filename: '',
                versions: []
            })
        ),
        on(
            IntegrationManagev2Actions.getConfigFiles,
            (state): IntegrationManagev2State => ({
                ...state,
                isSaving: true
            })
        ),
        on(
            IntegrationManagev2Actions.getFileContent,
            (state, action): IntegrationManagev2State => ({
                ...state,
                isSaving: true,
                filename: action.config.filename
            })
        ),
        on(
            IntegrationManagev2Actions.setConfigFiles,
            (state, action): IntegrationManagev2State => ({
                ...state,
                filenames: action.files,
                isSaving: false,
                fileContent: '',
                filename: ''
            })
        ),
        on(
            IntegrationManagev2Actions.setFileContent,
            (state, action): IntegrationManagev2State => ({
                ...state,
                fileContent: action.content,
                isSaving: false
            })
        ),
        on(
            IntegrationManagev2Actions.saveConfigFile,
            (state): IntegrationManagev2State => ({
                ...state,
                isSaving: true
            })
        ),
        on(
            IntegrationManagev2Actions.setIsSaving,
            (state, action): IntegrationManagev2State => ({
                ...state,
                isSaving: action.isSaving
            })
        ),
        on(
            IntegrationManagev2Actions.addConfigFile,
            (state): IntegrationManagev2State => ({
                ...state,
                isSaving: true
            })
        ),
        on(
            IntegrationManagev2Actions.newIntegration,
            (state): IntegrationManagev2State => ({
                ...state,
                isSaving: true
            })
        ),
        on(
            IntegrationManagev2Actions.getVersions,
            (state): IntegrationManagev2State => ({
                ...state,
                isSaving: true
            })
        ),
        on(
            IntegrationManagev2Actions.setVersions,
            (state, action): IntegrationManagev2State => ({
                ...state,
                isSaving: false,
                versions: action.versions,
                selectedVersion: action.selectedVersion
            })
        ),
        on(
            IntegrationManagev2Actions.createVersion,
            (state): IntegrationManagev2State => ({
                ...state,
                isSaving: true
            })
        ),
        on(
            IntegrationManagev2Actions.setPublishedVersion,
            (state): IntegrationManagev2State => ({
                ...state,
                isSaving: true
            })
        ),
        on(
            IntegrationManagev2Actions.getAllPublishedVersions,
            (state): IntegrationManagev2State => ({
                ...state,
                isSaving: true
            })
        ),
        on(
            IntegrationManagev2Actions.setAllPublishedVersions,
            (state, action): IntegrationManagev2State => ({
                ...state,
                isSaving: false,
                publishedVersions: action.publishedVersions
            })
        )
    )(reducerState, reducerAction);
};
